export default {"src":"/_next/static/media/ico-select-black.cce7fa5e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};